import { Form as EditForm } from '@/components/company/edit_form'
import { CurrentTenantContext } from '@/core/current_tenant_context'
import { useContext } from 'react'
import { Inline as Loading } from '@/components/loading'

export const CompanyDetails = () => {
  const { currentCompany } = useContext(CurrentTenantContext)

  if (!currentCompany?.id) return <Loading />

  return (
    <>
      <EditForm id={currentCompany.id} />
    </>
  )
}
